
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/api-keys",
      function () {
        return require("private-next-pages/api-keys/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/api-keys"])
      });
    }
  